import { PluginsForAnalysisResponse } from '../../interfaces/analysis';

export enum LoadingState {
  Loading = 'loading',
  Ready = 'ready',
  Error = 'error',
}

export interface AnalysisContextActions {
  viewResult: { status: LoadingState; url: string | null };
  plugins: { status: LoadingState; items: PluginsForAnalysisResponse[] };
}

export type DownloadType = 'results' | 'logs' | 'raw';
